import { Table, TableName } from '@openx/components-table/Table.tsx';
import type { ProvidersList as ProvidersListType } from '@openx/types/provider.ts';
import type { AllTableCriteria, CriteriaChange, CriteriaDimension } from '@openx/types/tableCriteria.ts';
import { useProviderContext } from '../../utils/context/ProviderContext.tsx';
import type { ProvidersListFilters } from '../types.ts';
import { ProvidersTopBar } from './ProvidersTopBar.tsx';

export type ProvidersListProps = {
  criteria: AllTableCriteria<ProvidersListFilters>;
  handleCriteriaChange: (newCriteria: CriteriaChange<CriteriaDimension, ProvidersListFilters>) => void;
  loading: boolean;
  providers: ProvidersListType[];
};

export const ProvidersList = ({ criteria, handleCriteriaChange, loading, providers }: ProvidersListProps) => {
  const { useGetProvidersTableData } = useProviderContext();
  const { rowActions, tableColumns } = useGetProvidersTableData(criteria.filters?.phrase);

  return (
    <>
      <ProvidersTopBar criteria={criteria} onChange={handleCriteriaChange} />
      <Table
        name={TableName.PROVIDERS}
        columns={tableColumns}
        criteria={criteria}
        data={providers}
        loading={loading}
        onCriteriaChange={handleCriteriaChange}
        rowActions={rowActions}
      />
    </>
  );
};
